// The same rules as Go's provision.DeriveNames (internal/provision/plan.go).
// Kept in two places deliberately: the operator sees the names before the
// record exists, and the job derives nothing -- it provisions exactly what
// the record says. If these ever disagree, the record wins.
//
// These are prefill defaults, not a constraint. The fields stay editable,
// because a tenant whose derived name collides with an existing one needs an
// override, and a bucket name is unique across all of GCS, not just this
// project.
export function deriveNames(tenantId, project) {
	const id = String(tenantId || "");
	return {
		// A tenant id may contain hyphens; a BigQuery dataset name may not.
		dataset: id.replace(/-/g, "_"),
		bucket: `instantviewai-${id}`,
		serviceAccount: `tenant-${id}@${project}.iam.gserviceaccount.com`,
		// The -psql suffix, not a bare "tenant-<id>": a tenant may one day have
		// a second connection to something that is not Postgres, and renaming a
		// BigQuery connection means rebuilding every view that embeds it.
		connection: `tenant-${id}-psql`,
	};
}

// The project every tenant's resources live in. Configuration rather than a
// literal, on the same reasoning as keycloak.js's realm fallbacks, and
// defaulting to today's value so nothing changes without a deploy.
export const GCP_PROJECT = process.env.REACT_APP_GCP_PROJECT || "instantviewai-375314";
